import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import ScrapperHTML from "./ScrapperHTML";

const HtmlScrape = props => {

    const [Multifield1, updateMultifield1] = useState("");
    const [Multifield2, updateMultifield2] = useState("");

    const handleSubmitTwoTextImputs = e => {



    }


const ScrapperCall = text =>{
//alert(text);
  updateMultifield1(text);
}
    useEffect(() => {

        return () => {
            
        }
    }, [])

    return (

  <Paper className="paper-container">
        <div className="container">
          <form className="white" onSubmit={handleSubmitTwoTextImputs}>
          <TextField
                fullWidth
                id="Multifield1"
                label="Multifield1"
                className="Multifield1"
                value={Multifield1}
                onChange={e => updateMultifield1(e.target.value)}
                margin="dense"
              />
              <br></br>
              <TextField
                fullWidth
                id="Multifield2"
                label="Multifield2"
                className="Multifield2"
                value={Multifield2}
                onChange={e => updateMultifield2(e.target.value)}
                margin="dense"
              />
              <br></br>
              <br></br>
              <ScrapperHTML ScrapperCall={ScrapperCall}></ScrapperHTML>
              <br></br>
              <br></br>
            <br></br>

            <Button
              type="submit"
              value="Submit"
              variant="contained"
              color="secondary"
            >
              Create
            </Button>
          </form>
        </div>
      </Paper>
    )
};
export default HtmlScrape;